import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotificacionesService } from '../notificaciones.service';
import { environment } from 'src/environments/environment';
import { IApiResp } from 'src/app/interfaces/api-resp';
import { IAvisos } from 'src/app/interfaces/avisos';
import { IAvisosOpciones } from 'src/app/pages/tablas/avisos/avisosListOpciones';

@Injectable({
  providedIn: 'root'
})
export class AvisosService {

  avisosList: IAvisos = {}
  apiURL: string = environment.apiURL;

  constructor(
    private http: HttpClient,
    private router: Router,
    private notificacionesSrv: NotificacionesService,
  ) { }


  avisoNew(opciones: IAvisosOpciones) {
    const path = `${this.apiURL}/avisos/avisoNew`;
    return this.http.post<IApiResp>(path, opciones)
  }

  // Devulve la lista de los 100 últimos avisos de un cliente
  getLista(id_cliente: number) {
    const path = `${this.apiURL}/avisos/list/${id_cliente}`;
    const lista = this.http.get<IApiResp>(path)
    this.avisosList != lista;
    return lista;
  }

  // Devulve la lista de avisos
  getAvisosList(opciones: IAvisosOpciones) {
    const path = `${this.apiURL}/avisos/avisosList`;
    return this.http.post<IApiResp>(path, opciones)
  }
  // Delete 1 aviso
  delete(id: number) {
    const path = `${this.apiURL}/avisos/delete/${id}`;
    return this.http.get<IApiResp>(path)
  }


}
